import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import i18n from "i18next";

export const GroupHeading = ({ inputValue, children, isAllOptionsSelected, onSelectAll, onUnselectAll }) => {
  const handleClick = () => (isAllOptionsSelected ? onUnselectAll(children) : onSelectAll(children));

  const labelClassNames = classNames("sorted-list__filters-reset", "checkbox__group-heading-reset", isAllOptionsSelected ? "--red" : "--green");

  return (
    <div className="checkbox__group-heading">
      <span className="checkbox__group-heading-content">{children}</span>
      {!inputValue && (
        <a role="presentation" className={labelClassNames} onClick={handleClick}>
          {isAllOptionsSelected ? i18n.t("filters.unselectAll") : i18n.t("filters.selectAll")}
        </a>
      )}
    </div>
  );
};

GroupHeading.propTypes = {
  children: PropTypes.string,
  inputValue: PropTypes.string,
  isAllOptionsSelected: PropTypes.bool,
  onSelectAll: PropTypes.func,
  onUnselectAll: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/Common/Form/MultiSelect/GroupHeading.js